<template>
  <!-- Layout container -->
  <v-container fluid class="pa-0">
    <AppHeader />
    <AppSidebar />
    <!-- Main Content Area -->
    <v-main>
      <v-container fluid class="dashboard-container">
        <router-view></router-view>
      </v-container>
    </v-main>
    <AppFooter />
  </v-container>
</template>

<script>
export default {
  components: {
    AppFooter: () => import("./Footer.vue"),
    AppHeader: () => import("./Header.vue"),
    AppSidebar: () => import("./Sidebar.vue"),
  },

  data: () => ({
    drawer: null,
  }),

  created() {
    this.$vuetify.theme.dark = false;
  },

};
</script>

<style scoped>
.dashboard-container {
  padding: 20px;
}

.v-main_wrap {
  min-height: 100vh;
  /* Makes the main container cover the full viewport height */
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
}

.v-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 20px 0px;
}
</style>